import { render, staticRenderFns } from "./VQueryBuilderGroup.vue?vue&type=template&id=63ed7783"
import script from "./VQueryBuilderGroup.vue?vue&type=script&lang=js"
export * from "./VQueryBuilderGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports